import {FC} from "react";
import {Card} from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import useLaunchDateTile from "@oldDashboard/legacyHooks/useLaunchDateTile";
import Loader from "@/components/common/loader/loader";

interface LaunchDateTile { launchDates: any, launchSelected: String, timePeriodSelected: String, searching: boolean }
const LaunchDateTile: FC<LaunchDateTile> = ({launchDates, launchSelected, timePeriodSelected, searching}) => {
    
    const { isLoading, chartData } = useLaunchDateTile({launchSelected, timePeriodSelected, searching});
    if(launchDates.length == 0 || (!chartData?.series && !chartData?.options)) return null;
    
    return (
        <Card className="custom-card overflow-hidden pb-2" style={{height: '250px'}}>
            {isLoading && <Loader/> }
            <Card.Body>
                <div className="row">
                    <div className="col-12 mx-auto">
                        <div>
                            <h5 className="fw-semibold mb-0 text-center">Launch Duration</h5>
                            <div className="d-flex align-items-center justify-content-center">
                                <ReactApexChart options={chartData?.options} series={chartData?.series} type="pie" height={170} />
                            </div>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default LaunchDateTile;
